import { INCOMING_ACTIVITY } from 'botframework-webchat-core/lib/actions/incomingActivity';
import { POST_ACTIVITY } from 'botframework-webchat-core/lib/actions/postActivity';
export const isIncomingUserMessage = (action) => {
    var _a, _b, _c;
    return (action.type === INCOMING_ACTIVITY &&
        ((_a = action.payload.activity) === null || _a === void 0 ? void 0 : _a.type) === 'message' &&
        ((_c = (_b = action.payload.activity) === null || _b === void 0 ? void 0 : _b.from) === null || _c === void 0 ? void 0 : _c.role) === 'user');
};
export const isOutgoingUserMessage = (action) => {
    var _a, _b, _c;
    return (action.type === POST_ACTIVITY &&
        ((_a = action.payload.activity) === null || _a === void 0 ? void 0 : _a.type) === 'message' &&
        ((_c = (_b = action.payload.activity) === null || _b === void 0 ? void 0 : _b.from) === null || _c === void 0 ? void 0 : _c.role) === 'user');
};
export function onChatHistoryLoadedMiddleware(callback) {
    let hasOutgoingMessage = false;
    let hasIncomingMessage = false;
    return () => (next) => (action) => {
        if (!hasOutgoingMessage && !hasIncomingMessage && isIncomingUserMessage(action)) {
            hasIncomingMessage = true;
            callback();
        }
        hasOutgoingMessage = hasOutgoingMessage || isOutgoingUserMessage(action);
        return next(action);
    };
}
//# sourceMappingURL=onChatHistoryLoadedMiddleware.js.map